import { useEffect, useRef } from "react";
import { cx } from "class-variance-authority";
import styles from "./MockDefaultPlayer.module.css";

interface MockDefaultPlayerProps {
  className?: string;
  children: React.ReactNode;
  id: string;
  observeCell: (target: HTMLElement) => void;
}

export function MockDefaultPlayer({
  className,
  children,
  id,
  observeCell,
}: MockDefaultPlayerProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    observeCell(ref.current as HTMLElement);
  }, []);

  return (
    <div ref={ref} className={cx(className, styles.wrapper)} id={id}>
      {children}
    </div>
  );
}
